import type { EntryConfig } from "@/types/entryConfig";
import { EDITABLE_ANNOTATION_IMAGE_TYPES } from "@/utils/plotImageSequence";

export const supportsOutsideBoundaryAnnotationsForEntryConfig = (entryConfig?: EntryConfig): boolean =>
  Boolean(
    entryConfig &&
      EDITABLE_ANNOTATION_IMAGE_TYPES.includes(entryConfig.type as (typeof EDITABLE_ANNOTATION_IMAGE_TYPES)[number])
  );
